<template>
  <div class="appBody prh-main bg-grey-light min-height">
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->
    <course-top type="cadv" :currentItem=currentCourse :projectId="proId" :projectName="proName"></course-top>
    <van-tabs class="course-tabs mt-3" v-model="active">
      <van-tab title="课程">
        <course-mulu-component class="mt-3" type="adv" :curCourse="currentCourse">
        </course-mulu-component>
      </van-tab>
      <van-tab title="详情">
        <div v-if="courseDetail" class="course-detail px-4 mt-3 pb-20 bg-white color-33"
             v-html="DetailImg">
        </div>
        <no-data v-else text="暂无详情信息"></no-data>
      </van-tab>
    </van-tabs>

<!--  <little-footer :class="{'mb-5': currentCourse.payment !== 'solely'}"></little-footer>-->
<!--    <pay-footer v-if="!isFromCreator" type="cadvFoot" :item=currentCourse :isProjectCourse="isProCourse"-->
<!--                :isHasCourse="isHadCourse"></pay-footer>-->
    <little-footer></little-footer>
  </div>
</template>

<script>
  import CourseTop from '@/components/courseTop'
  import CourseMuluComponent from '@/components/courseMuluComponent'
  import payFooter from '@/components/payFooter';

  import littleFooter from '@/page/lecturer/components/littleFooter';

  import NoData from '@/components/noData';

  import Vue from 'vue';
  import {Tab, Tabs} from 'vant';
  import Cookies from "js-cookie";

  Vue.use(Tab);
  Vue.use(Tabs);

  export default {
    name: "courseAdv",
    components: {
      CourseMuluComponent,
      CourseTop,
      payFooter,
      littleFooter,
      NoData,
    },
    props: [
      'isHadCourse',
      'isFromCreator'
    ],
    data() {
      return {
        active: 0,
        loading: false,
        finished: false,
        courseMuluObj: {},
        DetailImg: '',
        currentCourse: {},
        shareObj: {},
        proId: '',
        proName: '',
        courseDetail: '',
        isProCourse: false,
      }
    },
    created() {
    },
    mounted() {
      this.courseId = this.$route.params['id'];
      this.proId = this.$route.query['proId'];
      this.proName = this.$route.query['proName'];

      if (this.proId) {
        this.isProCourse = true;
        this.getProjectCourse();
      } else {
        this.isProCourse = false;
        this.getCourse();
      }

    },
    methods: {

      getCourse() {
        this.$store.dispatch('getCourseForLearner', {id: this.courseId}).then((res) => {
          this.currentCourse = res;
          this.getMuluList();
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.currentCourse.title
          });
          sessionStorage.setItem("currentCourse", JSON.stringify(this.currentCourse));
        })
      },
      getProjectCourse() {
        this.$store.dispatch('getProjectCourseForLearner', {id: this.courseId, proId: this.proId}).then((res) => {
          if(res && res.course) {
            this.currentCourse = res.course;
          }
          this.getMuluList();
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.currentCourse.title
          });
          sessionStorage.setItem('currentCourse', JSON.stringify(this.currentCourse));
        })
      },
      getMuluList() {
        if (this.currentCourse) {
          this.courseDetail = this.currentCourse.detail;
          if (this.courseDetail) {
            this.$store.dispatch('getContent', {content: this.courseDetail}).then((res) => {
              this.DetailImg = res
            }).catch(function (error) {
              console.log(error);
            });
          }

        }
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.currentCourse;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = this.proId ? 'pcourse' : 'course';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },

    }
  }
</script>

<style>
  .course-detail p {
    text-indent: 2rem;
    font-size: .9375rem;
    line-height: 1.5rem;
    text-align: justify;
  }

  .course-detail img {
    width: 100%;
    height: 100%;
  }
</style>
